import { TextField, type TextFieldProps } from "@/shared/ui/core";

export interface MoneyFieldProps extends Omit<TextFieldProps, "placeholder"> {
  /** El código de la moneda: `"MXN"`. Solo se usa para el hueco de ejemplo. */
  currency?: string;
  /** El símbolo, si se conoce. Por omisión `$`. */
  symbol?: string;
}

/**
 * Un importe. Se escribe en PESOS —"1299.50", como se lee— y el
 * formulario lo guarda en CENTAVOS enteros.
 *
 * La conversión NO ocurre aquí: ocurre una sola vez, en
 * `productFormSchema`, con `parsePriceToCents` del contrato. Si cada
 * campo convirtiera lo suyo habría tantas conversiones como campos y
 * bastaría con que una redondeara distinto para que un total no cuadre.
 *
 * `inputMode="decimal"` y no `type="number"`: la rueda del ratón sobre un
 * `type="number"` cambia el valor, y sobre un precio eso es una rebaja
 * accidental que nadie ordenó.
 *
 * Candidato a `shared/ui/fields/` — el checkout lo va a necesitar igual.
 */
export function MoneyField({ currency, symbol = "$", ...rest }: MoneyFieldProps) {
  return (
    <TextField
      inputMode="decimal"
      autoComplete="off"
      placeholder={`${symbol} 0.00`}
      {...rest}
      // El código de moneda va al final del campo, no en el hueco: el
      // hueco desaparece al escribir y entonces dos campos idénticos
      // dejan de distinguirse.
      trailing={
        currency ? (
          <span
            aria-hidden="true"
            className="pr-2 text-[11px] font-semibold tracking-ds-label text-ds-ink-3"
          >
            {currency}
          </span>
        ) : undefined
      }
    />
  );
}
